import SocketIOClient from 'socket.io-client'

import { NODE_URL } from './'

export const socket = SocketIOClient(NODE_URL, {
    transports: ["websocket"]
});

